export const de = {
  // ============================================================
  // GLOBAL UI — Always Visible
  // ============================================================

  // Navigation
  "nav.solutions": "Leistungen",
  "nav.projects": "Projekte",
  "nav.contact": "Kontakt",
  "nav.cta": "ERSTGESPRÄCH BUCHEN",
  "nav.blog": "Blog",
  "nav.customers": "Kunden",
  "nav.partners": "Partner",
  "nav.aicheck": "AI Check",
  "nav.techradar": "Tech Radar",
  "nav.playbook": "AI Playbook",

  // Cookie Consent
  "cookie.title": "Cookie-Einstellungen",
  "cookie.description": "Wir verwenden Cookies und ähnliche Technologien für Analyse, Marketing und erweiterte Fehleranalyse.",
  "cookie.acceptAll": "Alle akzeptieren",
  "cookie.rejectAll": "Nur notwendige",
  "cookie.link": "Mehr in unserer Datenschutzerklärung",

  // Cookie Gate (page-level consent requirement)
  "cookieGate.title": "Cookie-Zustimmung erforderlich",
  "cookieGate.description": "Um den AI Readiness Check nutzen zu können, benötigen wir Ihre Zustimmung zur Verwendung von Analyse-Cookies. Diese helfen uns, das Erlebnis zu verbessern und Ihnen personalisierte Ergebnisse zu liefern.",
  "cookieGate.privacy": "Mehr Informationen in unserer",
  "cookieGate.privacyLink": "Datenschutzerklärung",
  "cookieGate.acceptButton": "Cookies akzeptieren",

  // Theme
  "theme.switchToLight": "Helles Design",
  "theme.switchToDark": "Dunkles Design",

  // Common
  "common.aiGeneratedImage": "KI-generiertes Bild",

  // ============================================================
  // HOMEPAGE — Sections in Render Order
  // ============================================================

  // Hero
  "hero.badge": "Nur produktionsreife Systeme",
  "hero.title.line1": "SOFTWARE &",
  "hero.title.line2": "KI-LÖSUNGEN",
  "hero.title.line3": "FÜR",
  "hero.title.line4": "UNTERNEHMEN.",

  "hero.subtitle": "Von der Idee zum produktionsreifen System —",
  "hero.subtitle.highlight": "in Wochen, nicht Jahren.",
  "hero.rotate.0": "Maßgeschneiderte Software, KI & Cloud für Unternehmen.",
  "hero.rotate.1": "Cloud-native. API-first. Production-ready.",
  "hero.rotate.2": "Weniger Meetings, mehr Ergebnisse. Direkt mit dem Architekten.",
  "hero.rotate.3": "KI, Mobile, Web & Cloud — alles aus einer Hand.",
  "hero.cta.primary": "KOSTENLOSES ERSTGESPRÄCH",
  "hero.cta.secondary": "SO ARBEITEN WIR",

  // Stats
  "stats.timeToMVP.label": "Time-to-MVP",
  "stats.timeToMVP.value": "6–8 Wochen",
  "stats.experience.label": "Jahre Erfahrung",
  "stats.experience.value": "10+",
  "stats.clients.label": "Enterprise & KMU Kunden",
  "stats.clients.value": "✓",
  "stats.focus.label": "Fokus",
  "stats.focus.value": "Web • Mobile • KI",

  // Customers & Partners
  "partners.label": "Vertrauen von",
  "partners.title": "KUNDEN & PARTNER",
  "partners.description": "Von Startups bis zu Konzernen — Kunden, die auf unsere Expertise vertrauen.",

  // Featured News
  "news.label": "Aktuelles",
  "news.title": "WAS GERADE PASSIERT",
  "news.cta": "Weiterlesen",

  // Solutions
  "solutions.label": "Unsere Kernbereiche",
  "solutions.title": "LEISTUNGEN",
  "solutions.description": "Wir digitalisieren Geschäftsprozesse — von der ersten Idee bis zum laufenden System.",
  "solutions.ai.title": "KI & AUTOMATISIERUNG",
  "solutions.ai.desc": "Wir automatisieren Ihre zeitfressende Büroarbeit und machen Firmenwissen per Chat durchsuchbar — von der Angebotserstellung bis zur Kundenkommunikation.",
  "solutions.ai.item1": "Firmenwissen per Chat durchsuchen",
  "solutions.ai.item2": "Büroprozesse automatisieren",
  "solutions.ai.item3": "KI in bestehende Tools integrieren",
  "solutions.ai.item4": "Datenschutzkonforme KI auf Ihren Servern",
  "solutions.ai.cta": "Mehr erfahren",
  "solutions.web.title": "WEB APPLIKATIONEN",
  "solutions.web.desc": "Vom interaktiven Kundenportal bis zur komplexen SaaS-Plattform — hochperformante Webanwendungen, die Ihre Geschäftsprozesse digitalisieren.",
  "solutions.web.stack": "z.B. Kundenportal, Buchungsplattform, SaaS-Lösung",
  "solutions.devops.title": "DEVOPS & CLOUD",
  "solutions.devops.desc": "Ihre IT-Infrastruktur zuverlässig in die Cloud bringen — mit automatischen Updates, Monitoring und null Ausfallzeit.",
  "solutions.devops.stack": "z.B. Cloud-Migration, automatisierte Deployments, Monitoring",
  "solutions.mobile.title": "MOBILE APPS",
  "solutions.mobile.desc": "Eine App für iPhone und Android gleichzeitig — damit Ihre Mitarbeiter im Außendienst und Ihre Kunden unterwegs alles im Griff haben.",
  "solutions.mobile.stack": "z.B. Zeiterfassung für Monteure, Fuhrpark-App, Bestell-App",
  "solutions.backend.title": "BACKEND SYSTEME",
  "solutions.backend.desc": "Die unsichtbare Technik hinter Ihrer Software: sichere Schnittstellen, schnelle Datenbanken und Systeme, die mitwachsen.",
  "solutions.backend.stack": "z.B. API für Ihre App, Datenmigration, System-Integration",
  "solutions.consulting.title": "CONSULTING",
  "solutions.consulting.desc": "Unabhängige Beratung zu Technologie, Cybersecurity und Regulierung.",
  "solutions.consulting.stack": "z.B. Tech-Audit, Threat Modeling, EU AI Act · CRA · NIS2",
  "solutions.cta.title": "Bereit für den nächsten Schritt?",
  "solutions.cta.desc": "Vereinbaren Sie ein kostenloses Erstgespräch.",

  // Packages / Productized Offers
  "packages.label": "Unsere Pakete",
  "packages.title": "KLARE LEISTUNGEN, KLARE PREISE",
  "packages.description": "Drei Einstiegspakete mit definiertem Scope, Zeitrahmen und Startpreis — damit Sie wissen, was Sie bekommen.",
  "packages.featured.badge": "Beliebtestes Paket",

  "packages.aisprint.name": "AI Sprint",
  "packages.aisprint.tagline": "KI erstmals testen, einen Prozess automatisieren",
  "packages.aisprint.price": "ab EUR 5.000",
  "packages.aisprint.duration": "2 Wochen",
  "packages.aisprint.ideal": "Ideal für: Erste KI-Erfahrung sammeln, einen konkreten Prozess automatisieren",
  "packages.aisprint.cta": "AI Sprint anfragen",
  "packages.aisprint.d1": "Workshop zur Identifikation des besten Use Cases",
  "packages.aisprint.d2": "Funktionierender KI-Prototyp",
  "packages.aisprint.d3": "Dokumentation & Handover",
  "packages.aisprint.d4": "ROI-Einschätzung für Skalierung",
  "packages.aisprint.d5": "30 Tage Support nach Abschluss",

  "packages.assessment.name": "Tech Assessment",
  "packages.assessment.tagline": "Unabhängiger Audit Ihrer bestehenden Systeme",
  "packages.assessment.price": "ab EUR 2.500",
  "packages.assessment.duration": "1 Woche",
  "packages.assessment.ideal": "Ideal für: Klarheit über den Zustand Ihrer IT, vor Invest-Entscheidungen",
  "packages.assessment.cta": "Assessment anfragen",
  "packages.assessment.d1": "Code- und Architektur-Review",
  "packages.assessment.d2": "Security & Performance Check",
  "packages.assessment.d3": "Priorisierter Maßnahmenplan",
  "packages.assessment.d4": "Präsentation der Ergebnisse",
  "packages.assessment.d5": "Optionale Umsetzungsbegleitung",

  "packages.mvp.name": "MVP Delivery",
  "packages.mvp.tagline": "Vollständiges Minimum Viable Product",
  "packages.mvp.price": "ab EUR 15.000",
  "packages.mvp.duration": "6–8 Wochen",
  "packages.mvp.ideal": "Ideal für: Neue Produkte schnell am Markt testen, Investoren-Demo",
  "packages.mvp.cta": "MVP besprechen",
  "packages.mvp.d1": "Product Discovery Workshop",
  "packages.mvp.d2": "UX/UI Design",
  "packages.mvp.d3": "Entwicklung (Frontend + Backend)",
  "packages.mvp.d4": "Deployment",
  "packages.mvp.d5": "3 Monate Wartung & Support",

  "packages.unsure": "Nicht sicher, welches Paket passt?",
  "packages.unsure.cta": "AI Readiness Check machen",
  "packages.custom": "Größeres Projekt?",
  "packages.custom.desc": "Für komplexere Anforderungen erstellen wir ein individuelles Angebot.",
  "packages.custom.cta": "Individuelles Angebot anfragen",

  // Process Section
  "process.label": "Unser Ablauf",
  "process.title": "WIE WIR ARBEITEN",
  "process.description": "Von der ersten Idee bis zur produktiven Lösung — transparent, strukturiert und ohne Umwege.",
  "process.step1.title": "Erstgespräch",
  "process.step1.desc": "30-minütiger kostenloser Call. Wir verstehen Ihre Herausforderung und klären, ob wir der richtige Partner sind.",
  "process.step2.title": "Analyse & Konzept",
  "process.step2.desc": "Gemeinsamer Workshop zur technischen Machbarkeitsprüfung, Architektur-Skizze und klaren Scope-Definition mit Aufwandsschätzung.",
  "process.step3.title": "Agile Umsetzung",
  "process.step3.desc": "2-Wochen-Sprints mit direkter Kommunikation. Kein Mittelsmann — Sie sprechen direkt mit dem Entwickler.",
  "process.step4.title": "Testing & Launch",
  "process.step4.desc": "Umfangreiches QA, Deployment in Production und aktives Monitoring in den ersten Betriebswochen.",
  "process.step5.title": "Wartung & Weiterentwicklung",
  "process.step5.desc": "Kontinuierlicher Support, iterative Verbesserungen und Skalierung mit Ihrem Wachstum.",
  "process.cta": "JETZT ERSTGESPRÄCH BUCHEN",

  // Expertise
  "expertise.title.line1": "Direkter Zugriff auf Expertise.",
  "expertise.title.highlight": "Keine Filter.",
  "expertise.description1": "Ing. Martin Haintz — Gründer und Geschäftsführer von HAINTZ IT-SOLUTIONS. Kein Vermittler, keine Account-Manager: Sie sprechen direkt mit dem Architekten, der Ihr System baut.",
  "expertise.description2": "Spezialisiert auf KI, Mobile, Web, Backend und DevOps.",
  "expertise.feature1.title": "Full-Stack Expertise",
  "expertise.feature1.desc": "Von KI-Pipelines über Flutter-Apps bis zu Cloud-Infrastruktur — alles aus einer Hand.",
  "expertise.feature2.title": "Schnell in Produktion",
  "expertise.feature2.desc": "Iterative Entwicklung für messbaren ROI in Wochen, nicht Jahren.",
  "expertise.feature3.title": "Enterprise-Erfahrung",
  "expertise.feature3.desc": "Projekte für Merck KGaA, OTTO, Sentry und weitere internationale Unternehmen.",
  "expertise.image.label.position": "Ing. Martin Haintz — Gründer & Geschäftsführer",
  "expertise.image.label.text": "AI · Mobile · Web · Backend · DevOps",

  // Tech Stack
  "techstack.label": "Unser Stack",
  "techstack.title": "TECHNOLOGIEN",
  "techstack.description": "KI · Mobile · Web · Backend · DevOps — unsere Kern-Technologien im aktiven Einsatz.",
  "techstack.viewAll": "Vollständige Liste im Tech Radar",

  // Projects
  "projects.label": "Referenzprojekte",
  "projects.title": "PROJEKTE",
  "projects.description": "Ausgewählte Projekte, die zeigen, wie wir konkrete Geschäftsprobleme in funktionierende Lösungen übersetzen.",
  "projects.viewAll": "Alle Projekte ansehen",
  "projects.challenge": "Herausforderung",
  "projects.solution": "Lösung",
  "projects.results": "Ergebnisse",
  "projects.techstack": "Technologie-Stack",
  "projects.cta.title": "Ähnliches Projekt?",
  "projects.cta.desc": "Lassen Sie uns besprechen, wie wir Ihre spezifische Herausforderung lösen können.",
  "projects.cta.button": "PROJEKT BESPRECHEN",
  "projects.back": "Alle Projekte",
  "projects.readMore": "Details lesen",

  // Testimonials
  "testimonials.label": "Was unsere Kunden sagen",
  "testimonials.title": "TESTIMONIALS",

  // Compliance / Trust Section
  "compliance.label": "Sicherheit & Compliance",
  "compliance.title": "VERTRAUEN DURCH TRANSPARENZ",
  "compliance.description": "Wie wir Ihre Daten und Systeme schützen.",
  "compliance.regulation.title": "EU AI Act · CRA · NIS2",
  "compliance.regulation.desc": "Drei Rechtsakte, die bis in den Code reichen. Wir kennen ihre technischen Folgen und bauen entsprechend.",
  "compliance.eu.title": "EU-FIRST",
  "compliance.eu.desc": "Wir bevorzugen europäische Serverstandorte und Anbieter für höchste Datenschutzstandards.",
  "compliance.ownership.title": "SOURCE CODE",
  "compliance.ownership.desc": "Nach Projektabschluss bekommen Sie den Quellcode. Kein Vendor Lock-in.",
  "compliance.encryption.title": "VERSCHLÜSSELUNG",
  "compliance.encryption.desc": "TLS/HTTPS für alle Kommunikation. Verschlüsselte Daten at Rest.",
  "compliance.onpremise.title": "ON-PREMISE OPTION",
  "compliance.onpremise.desc": "KI-Modelle und Datenverarbeitung auf Ihren eigenen Servern möglich.",
  "compliance.audits.title": "SICHERHEITSAUDITS",
  "compliance.audits.desc": "Regelmäßige Security-Checks gewährleisten höchste Systemintegrität und Schutz vor Bedrohungen.",
  "compliance.cta": "Mehr zu unserem Datenschutz",
  "compliance.regulation.cta": "Was die drei Rechtsakte für die Entwicklung ändern: Consulting",

  // FAQ Section
  "faq.label": "Häufige Fragen",
  "faq.title": "DAS WERDEN WIR OFT GEFRAGT",
  "faq.q1": "Brauche ich technisches Vorwissen für eine Zusammenarbeit?",
  "faq.a1": "Nein, überhaupt nicht. Wir erklären alles in verständlicher Sprache und führen Sie Schritt für Schritt durch den gesamten Prozess. Unser Job ist es, die Technik im Hintergrund für Sie arbeiten zu lassen.",
  "faq.q3": "Wie lange dauert ein Projekt?",
  "faq.a3": "Ein erster Prototyp steht typischerweise in 2–4 Wochen. Komplette Systeme brauchen für gewöhnlich 2–4 Monate. Sie sehen regelmäßig Zwischenergebnisse und können jederzeit Feedback geben.",
  "faq.q4": "Arbeiten Sie auch mit kleinen Unternehmen?",
  "faq.a4": "Ja. Von Ein-Personen-Betrieben bis zum internationalen Konzern — die Lösung passt sich Ihrem Budget und Ihren Anforderungen an.",
  "faq.q5": "Was passiert nach dem Projekt?",
  "faq.a5": "Wir bieten Wartung, Support und Weiterentwicklung an. Ihre Software bleibt aktuell und sicher — und wächst mit Ihrem Unternehmen mit.",
  "faq.q6": "Ich brauche eine ganz normale App oder Website ohne KI. Machen Sie das auch?",
  "faq.a6": "Selbstverständlich. KI ist ein mächtiges Werkzeug, aber nicht für jedes Problem die richtige Lösung. Wir entwickeln hochwertige klassische Web- und Mobile-Apps, Portale und Backend-Systeme — genau auf Ihre Anforderungen zugeschnitten.",
  "faq.q7": "Wo liegen meine Daten und ist das alles DSGVO-konform?",
  "faq.a7": "Datenschutz hat bei uns oberste Priorität. Wir setzen auf Server-Standorte in Europa (oft On-Premise oder Private Cloud) und achten bei allen Systemen, insbesondere bei KI-Anwendungen, auf strikte DSGVO-Konformität.",
  "faq.q8": "Wem gehört die fertige Software nach Abschluss des Projekts?",
  "faq.a8": "Bei individuell entwickelter Software wird Ihnen der Quellcode übergeben — ohne Aufpreis, nicht erst auf Nachfrage. Mit der vollständigen Bezahlung erhalten Sie ein zeitlich und räumlich unbeschränktes, einfaches Nutzungsrecht; ab dann dürfen Sie den Quellcode intern oder durch beauftragte Dritte weiterentwickeln lassen. Für Open-Source-Komponenten gelten die jeweiligen Lizenzen. Sie binden sich also nicht durch technische Hürden an uns.",
  "faq.q9": "Wie starte ich am besten?",
  "faq.a9": "Am einfachsten über unser kostenloses 30-Minuten-Erstgespräch. Dabei verstehen wir Ihre Herausforderung, prüfen ob wir der richtige Partner sind und geben Ihnen eine ehrliche Einschätzung zu Aufwand und Kosten. Ganz unverbindlich.",
  "faq.q10": "Woher weiß ich, ob KI für mein Unternehmen sinnvoll ist?",
  "faq.a10": "Starten Sie mit unserem kostenlosen AI Readiness Assessment — ein 2-Minuten-Check direkt auf unserer Website. Für eine tiefere Analyse bieten wir den AI Sprint an, der in wenigen Tagen konkrete Ergebnisse liefert. Und keine Sorge: Nicht jedes Problem braucht KI. Wenn eine klassische Lösung besser passt, sagen wir Ihnen das offen.",

  // Contact
  "contact.title.line1": "Lassen Sie uns",
  "contact.title.line2": "umsetzen.",
  "contact.description": "Sie haben eine Vision, wir haben die Kapazität sie zu bauen. Vereinbaren Sie ein unverbindliches Erstgespräch direkt mit dem Gründer und Geschäftsführer.",
  "contact.location": "Graz / Steiermark, Austria",
  "contact.portrait.role": "Gründer & Geschäftsführer",
  "contact.form.name": "Name",
  "contact.form.name.placeholder": "Max Mustermann",
  "contact.form.email": "E-Mail",
  "contact.form.email.placeholder": "m.mustermann@firma.at",
  "contact.form.subject": "Betreff",
  "contact.form.subject.ai": "KI & Automation",
  "contact.form.subject.software": "Individualsoftware",
  "contact.form.subject.infra": "Infrastruktur & Cloud",
  "contact.form.subject.other": "Sonstiges",
  "contact.form.message": "Nachricht",
  "contact.form.message.placeholder": "Beschreiben Sie kurz Ihr Vorhaben...",
  "contact.form.submit": "NACHRICHT SENDEN",
  "contact.form.sending": "WIRD GESENDET...",
  "contact.form.success": "Nachricht erfolgreich gesendet!",
  "contact.form.error": "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder schreiben Sie an {email}.",

  // ============================================================
  // SUBPAGES — Service Detail Pages
  // ============================================================

  // Service Pages — Common
  "service.cta.title": "Bereit loszulegen?",
  "service.cta.desc": "Vereinbaren Sie ein kostenloses Erstgespräch und erfahren Sie, wie wir Ihr Projekt realisieren.",
  "service.cta.button": "KOSTENLOSES ERSTGESPRÄCH",
  "service.back": "Zurück zur Übersicht",

  // Service — AI & Automation
  "service.ai.label": "Unsere KI-Leistungen",
  "service.ai.title": "KI & AUTOMATISIERUNG",
  "service.ai.description": "Wir integrieren KI dort, wo sie echten Mehrwert erzeugt: RAG-Systeme, KI-Agenten, MCP-Server und intelligente Workflow-Automatisierung für KMUs und Enterprise-Kunden.",
  "service.ai.benefit1.title": "RAG & Wissenssysteme",
  "service.ai.benefit1.desc": "Durchsuchen Sie Ihre eigenen Dokumente, Datenbanken und Wissensbasen mittels natürlichsprachiger Suche.",
  "service.ai.benefit2.title": "KI-Agenten & MCP",
  "service.ai.benefit2.desc": "Autonome Agenten, die komplexe Aufgaben ausführen und über MCP-Server in Ihre Tools integriert sind.",
  "service.ai.benefit3.title": "n8n Workflow Automation",
  "service.ai.benefit3.desc": "No-Code Workflows mit 400+ App-Integrationen — self-hosted und DSGVO-konform. Von Slack bis SAP, inklusive KI-gestützte E-Mail-Klassifizierung und Dokumentenanalyse.",
  "service.ai.benefit4.title": "Local & Private LLMs",
  "service.ai.benefit4.desc": "On-Premise KI mit Ollama / llama.cpp — maximale Datensicherheit für sensible Unternehmensdaten.",
  "service.ai.usecase1": "Kundenservice-Chatbot mit Produktwissen-RAG",
  "service.ai.usecase2": "Automatische Dokumentenklassifizierung und -extraktion",
  "service.ai.usecase3": "Interne Wissensdatenbank für Mitarbeiter",
  "service.ai.usecase4": "Lead-Scoring und CRM-Anreicherung mit KI",
  "service.ai.usecase5": "Automatische Lead-Erfassung und CRM-Synchronisierung",
  "service.ai.usecase6": "Rechnungsverarbeitung und Buchhaltungs-Automatisierung",
  "service.ai.usecase7": "Social Media und Content-Automatisierung",
  "service.ai.usecase8": "HR-Onboarding und Mitarbeiter-Workflows",

  // Service — Mobile Apps
  "service.mobile.label": "Flutter App Entwicklung",
  "service.mobile.title": "MOBILE APPS",
  "service.mobile.description": "Cross-platform Apps für iOS und Android mit Flutter — ein Codebase, zwei Stores, native Performance.",
  "service.mobile.benefit1.title": "Cross-Platform mit Flutter",
  "service.mobile.benefit1.desc": "Eine Codebase für iOS, Android und Web. 60% schnellere Entwicklung bei nativem Look & Feel.",
  "service.mobile.benefit2.title": "App Store Ready",
  "service.mobile.benefit2.desc": "Von der Architektur bis zur Veröffentlichung — wir begleiten Sie durch den gesamten App-Store-Prozess.",
  "service.mobile.benefit3.title": "Backend-Integration",
  "service.mobile.benefit3.desc": "Nahtlose Anbindung an REST-APIs, Firebase, Supabase oder Ihr bestehendes Backend.",
  "service.mobile.benefit4.title": "Offline-First",
  "service.mobile.benefit4.desc": "Apps, die auch ohne Internetverbindung funktionieren — kritisch für Außendienst und Feldanwendungen.",
  "service.mobile.usecase1": "B2B-Außendienst-Apps mit Offline-Synchronisation",
  "service.mobile.usecase2": "Flottenmanagement und Logistik-Apps",
  "service.mobile.usecase3": "E-Commerce und Marketplace Apps",
  "service.mobile.usecase4": "IoT-Steuerungs-Apps für Industrieanwendungen",

  // Service — Web Applications
  "service.web.label": "Web-Entwicklung",
  "service.web.title": "WEB APPLIKATIONEN",
  "service.web.description": "High-Performance Web-Applikationen mit Next.js und React — vom interaktiven Kundenportal bis zur komplexen SaaS-Plattform.",
  "service.web.benefit1.title": "Next.js & React",
  "service.web.benefit1.desc": "Server-Side Rendering, statische Generierung und Edge-Deployment für maximale Performance und SEO.",
  "service.web.benefit2.title": "TypeScript First",
  "service.web.benefit2.desc": "Typsichere Codebases, die skalieren. Weniger Bugs, bessere Wartbarkeit, schnellere Onboarding-Zeit.",
  "service.web.benefit3.title": "API-First & Integration",
  "service.web.benefit3.desc": "Nahtlose Anbindung an Ihre bestehende IT-Infrastruktur — von ERP- und CRM-Systemen bis hin zu Legacy-Datenbanken.",
  "service.web.benefit4.title": "Performance-Optimierung",
  "service.web.benefit4.desc": "Core Web Vitals, Lighthouse-Scores > 90 und Cloudflare-Deployment für globale Latenz < 50ms.",
  "service.web.usecase1": "Individualsoftware und interne Tools",
  "service.web.usecase2": "B2B-Kundenportale und Dashboards",
  "service.web.usecase3": "SaaS-Plattformen und Multi-Tenant-Systeme",
  "service.web.usecase4": "E-Commerce und Buchungsplattformen",

  // Service — Backend
  "service.backend.label": "Backend-Entwicklung",
  "service.backend.title": "BACKEND ENTWICKLUNG",
  "service.backend.description": "Robuste, skalierbare Backend-Systeme mit Node.js oder Python — von REST-APIs bis zu Event-Driven Architekturen.",
  "service.backend.benefit1.title": "API-Design & Entwicklung",
  "service.backend.benefit1.desc": "RESTful APIs mit OpenAPI-Dokumentation — wartbar, versioniert und gut dokumentiert.",
  "service.backend.benefit2.title": "Datenbankarchitektur",
  "service.backend.benefit2.desc": "PostgreSQL, MongoDB, Redis — richtige Wahl für jeden Use Case mit Migrations-Management und Performance-Tuning.",
  "service.backend.benefit3.title": "Microservices & Event-Driven",
  "service.backend.benefit3.desc": "Entkoppelte Architekturen mit Message Queues (RabbitMQ) für skalierbare, resiliente Systeme.",
  "service.backend.benefit4.title": "Auth & Security",
  "service.backend.benefit4.desc": "OAuth2, OIDC, JWT — sichere Authentifizierung und Autorisierung nach aktuellem Stand der Technik.",
  "service.backend.usecase1": "REST APIs für Mobile und Web",
  "service.backend.usecase2": "Echtzeit-Systeme mit WebSockets",
  "service.backend.usecase3": "Daten-Pipelines und ETL-Prozesse",
  "service.backend.usecase4": "Legacy-System-Integration und -Migration",

  // Service — DevOps
  "service.devops.label": "DevOps & Infrastruktur",
  "service.devops.title": "DEVOPS & INFRASTRUKTUR",
  "service.devops.description": "Cloud-Infrastruktur, CI/CD-Pipelines und GitOps — damit Ihr Code zuverlässig und sicher in Production läuft.",
  "service.devops.benefit1.title": "Infrastructure as Code",
  "service.devops.benefit1.desc": "Terraform/OpenTofu und Ansible für reproduzierbare, versionierte Infrastruktur auf AWS, Azure, GCP oder Cloudflare.",
  "service.devops.benefit2.title": "CI/CD & GitOps",
  "service.devops.benefit2.desc": "GitHub Actions — automatisierte Pipelines von Commit bis Production-Deployment.",
  "service.devops.benefit3.title": "Container",
  "service.devops.benefit3.desc": "Docker für portable, skalierbare Deployments — on-premise oder in der Cloud.",
  "service.devops.benefit4.title": "Monitoring & Observability",
  "service.devops.benefit4.desc": "Prometheus, Grafana, Sentry — vollständige Sichtbarkeit in Ihre Systeme mit proaktivem Alerting.",
  "service.devops.usecase1": "Cloud-Migration von On-Premise zu AWS/Azure",
  "service.devops.usecase2": "Aufbau von Zero-Downtime Deployment Pipelines",
  "service.devops.usecase3": "Self-Hosting & Private Cloud Setup mit Proxmox",
  "service.devops.usecase4": "Infrastruktur-Automatisierung mit Ansible",

  // Service — Consulting
  "service.consulting.label": "Beratung",
  "service.consulting.title": "CONSULTING",
  "service.consulting.description": "Unabhängige Beratung zu Technologie, Cybersecurity und Regulierung. Wir entscheiden mit Ihnen, was gebaut wird, wie es abgesichert wird, und was die drei EU-Rechtsakte davon berühren, die bis in den Code reichen.",
  "service.consulting.notice": "Der Abschnitt zur Regulatorik beschreibt technische Konsequenzen für Entwicklung und Betrieb — keine Rechtsberatung. Ob einer dieser Rechtsakte für Ihr Unternehmen gilt und welche Pflichten daraus folgen, beurteilen wir nicht.",
  "service.consulting.benefit1.title": "Technologie & Architektur",
  "service.consulting.benefit1.desc": "Neutrale Bewertung von Tech-Stacks, Architekturen und Vendor-Lösungen auf Basis Ihrer Anforderungen — Make-or-buy, Datenstrategie, realistische Aufwände statt Roadmap-Prosa.",
  "service.consulting.benefit2.title": "Cybersecurity",
  "service.consulting.benefit2.desc": "Threat Modeling, Security-Reviews und Härtung vor dem Go-live: wo jemand angreifen würde, was die Absicherung kostet und welche Prüfungen in die CI/CD-Pipeline gehören.",
  "service.consulting.benefit3.title": "Regulatorik",
  "service.consulting.benefit3.desc": "EU AI Act, Cyber Resilience Act und NIS-2-Richtlinie reichen bis in den Code: nachvollziehbare KI-Funktionen mit protokollierten Ein- und Ausgaben, SBOM und Update-Pfad im Release, auditierbare Zugriffe und geprüfte Wiederanläufe im Betrieb.",
  "service.consulting.benefit4.title": "CTO-as-a-Service",
  "service.consulting.benefit4.desc": "Temporäre technische Führung für Startups und KMU — Entscheidungen, Projekt-Oversight und technische Steuerung von Drittanbietern, ohne Festanstellung. Beratung zu allen drei Feldern läuft hier, nicht als eigenes Paket.",
  "service.consulting.usecase1": "Tech-Stack- und Make-or-buy-Entscheidung vor dem Projektstart",
  "service.consulting.usecase2": "Security-Review und Threat Modeling für ein bestehendes System",
  "service.consulting.usecase3": "SBOM, Update-Pfad und Audit-Logs im Release verankern",
  "service.consulting.usecase4": "Technische Due Diligence einer Codebasis vor M&A oder Investment",

  // ============================================================
  // SUBPAGES — Other
  // ============================================================

  // AI Readiness Assessment — Intro
  "aicheck.label": "Kostenloser AI-Check",
  "aicheck.title": "AI READINESS ASSESSMENT",
  "aicheck.description": "Finden Sie in 2 Minuten heraus, wie bereit Ihr Unternehmen für KI-Integration ist — und welche konkreten Schritte den größten Impact haben.",
  "aicheck.cta.start": "CHECK STARTEN",
  "aicheck.duration": "~ 2 Minuten · 7 Fragen · Sofort-Ergebnis",

  // AI Readiness Assessment — Progress
  "aicheck.progress.question": "Frage",
  "aicheck.progress.of": "von",

  // AI Readiness Assessment — Question 1
  "aicheck.q1.title": "Wie viel der Arbeit Ihres Teams besteht aus repetitiver Datenverarbeitung?",
  "aicheck.q1.opt1": "Sehr wenig (< 10%)",
  "aicheck.q1.opt2": "Etwas (10–25%)",
  "aicheck.q1.opt3": "Moderat (25–50%)",
  "aicheck.q1.opt4": "Viel (50–75%)",
  "aicheck.q1.opt5": "Sehr viel (> 75%)",

  // AI Readiness Assessment — Question 2
  "aicheck.q2.title": "Haben Sie bereits digitalisierte und strukturierte Daten?",
  "aicheck.q2.opt1": "Nein, alles auf Papier",
  "aicheck.q2.opt2": "Teilweise digital, aber unstrukturiert",
  "aicheck.q2.opt3": "Größtenteils digital in verschiedenen Systemen",
  "aicheck.q2.opt4": "Gut strukturierte Datenbanken vorhanden",
  "aicheck.q2.opt5": "Vollständig digitalisiert mit APIs",

  // AI Readiness Assessment — Question 3
  "aicheck.q3.title": "Wie viele Kundenanfragen bearbeiten Sie pro Woche?",
  "aicheck.q3.opt1": "Weniger als 10",
  "aicheck.q3.opt2": "10–50",
  "aicheck.q3.opt3": "50–200",
  "aicheck.q3.opt4": "200–500",
  "aicheck.q3.opt5": "Über 500",

  // AI Readiness Assessment — Question 4
  "aicheck.q4.title": "Verwenden Sie bereits Automatisierungstools?",
  "aicheck.q4.opt1": "Nein, alles manuell",
  "aicheck.q4.opt2": "Einfache Skripte oder Makros",
  "aicheck.q4.opt3": "Einige Tools (Zapier, Make, etc.)",
  "aicheck.q4.opt4": "Umfangreiche Automation vorhanden",
  "aicheck.q4.opt5": "Fortgeschrittene Orchestrierung & Workflows",

  // AI Readiness Assessment — Question 5
  "aicheck.q5.title": "Was ist Ihr Budgetrahmen für KI-Implementierung?",
  "aicheck.q5.opt1": "Unter EUR 5.000",
  "aicheck.q5.opt2": "EUR 5.000 – 15.000",
  "aicheck.q5.opt3": "EUR 15.000 – 50.000",
  "aicheck.q5.opt4": "EUR 50.000 – 100.000",
  "aicheck.q5.opt5": "Über EUR 100.000",

  // AI Readiness Assessment — Question 6
  "aicheck.q6.title": "Wie technikaffin ist Ihr Team?",
  "aicheck.q6.opt1": "Grundlegende PC-Kenntnisse",
  "aicheck.q6.opt2": "Routiniert mit Standard-Software",
  "aicheck.q6.opt3": "Power-User, nutzen verschiedene Tools",
  "aicheck.q6.opt4": "Technikaffin, einige Entwickler im Team",
  "aicheck.q6.opt5": "Hochgradig technisch, eigenes Dev-Team",

  // AI Readiness Assessment — Question 7
  "aicheck.q7.title": "In welchem Zeitrahmen möchten Sie Ergebnisse sehen?",
  "aicheck.q7.opt1": "Kein konkreter Zeitplan",
  "aicheck.q7.opt2": "Innerhalb von 6–12 Monaten",
  "aicheck.q7.opt3": "Innerhalb von 3–6 Monaten",
  "aicheck.q7.opt4": "Innerhalb von 1–3 Monaten",
  "aicheck.q7.opt5": "So schnell wie möglich",

  // AI Readiness Assessment — Navigation
  "aicheck.nav.back": "ZURÜCK",
  "aicheck.nav.next": "WEITER",
  "aicheck.nav.finish": "ERGEBNIS ANZEIGEN",

  // AI Readiness Assessment — Result
  "aicheck.result.label": "Ihr Ergebnis",
  "aicheck.result.title": "AI READINESS SCORE",
  "aicheck.result.tier1.title": "Einstiegsphase",
  "aicheck.result.tier1.desc": "Ihr Unternehmen steht am Anfang der KI-Reise. Wir empfehlen ein strategisches Beratungsgespräch, um die richtigen ersten Schritte zu identifizieren.",
  "aicheck.result.tier1.service": "Tech Consulting",
  "aicheck.result.tier2.title": "Aufbauphase",
  "aicheck.result.tier2.desc": "Gute Grundlagen vorhanden. Mit gezielter Prozessautomatisierung können Sie schnelle Erfolge erzielen — ideal für n8n-Workflows und erste KI-Integrationen.",
  "aicheck.result.tier2.service": "n8n Automation",
  "aicheck.result.tier3.title": "Bereit für KI",
  "aicheck.result.tier3.desc": "Ihr Unternehmen hat die ideale Ausgangslage für KI-Integration. RAG-Systeme, KI-Agenten oder intelligente Automatisierung können sofort Mehrwert liefern.",
  "aicheck.result.tier3.service": "KI & Automation",
  "aicheck.result.tier4.title": "KI-Vorreiter",
  "aicheck.result.tier4.desc": "Exzellente Voraussetzungen! Ihr Unternehmen kann fortgeschrittene KI-Lösungen wie autonome Agenten, Multi-Agent-Systeme und Custom LLMs einsetzen.",
  "aicheck.result.tier4.service": "KI & Automation",
  "aicheck.result.roi.label": "Geschätzte Effizienzsteigerung",
  "aicheck.result.recommendation.label": "Unsere Empfehlung",
  "aicheck.result.recommendation.cta": "LEISTUNG ANSEHEN",

  // AI Readiness Assessment — Email Capture
  "aicheck.email.title": "Ergebnisse per E-Mail erhalten",
  "aicheck.email.description": "Wir senden Ihnen eine detaillierte Auswertung mit konkreten Handlungsempfehlungen.",
  "aicheck.email.name": "Name",
  "aicheck.email.name.placeholder": "Max Mustermann",
  "aicheck.email.email": "E-Mail",
  "aicheck.email.email.placeholder": "m.mustermann@firma.at",
  "aicheck.email.submit": "ERGEBNISSE SENDEN",
  "aicheck.email.sending": "WIRD GESENDET...",
  "aicheck.email.success": "Ergebnisse wurden an Ihre E-Mail gesendet!",
  "aicheck.email.error": "Der Bericht konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder schreiben Sie an {email}.",

  // AI Readiness Assessment — CTA & Restart
  "aicheck.cta.title": "Bereit für den nächsten Schritt?",
  "aicheck.cta.desc": "Vereinbaren Sie ein kostenloses Erstgespräch — direkt mit dem Gründer.",
  "aicheck.cta.button": "ERSTGESPRÄCH BUCHEN",
  "aicheck.restart": "ASSESSMENT NEU STARTEN",

  // AI Readiness Assessment — Per-Question Insights
  "aicheck.insights.title": "Detaillierte Analyse",
  "aicheck.insights.desc": "Ihre Antworten im Detail — mit konkreten Empfehlungen pro Bereich.",
  "aicheck.insights.answer": "Ihre Antwort",
  "aicheck.insights.insight": "Was das bedeutet",
  "aicheck.insights.action": "Empfehlung",

  // Q1: Repetitive Datenverarbeitung
  "aicheck.insight.q1.low": "Wenig repetitive Arbeit bedeutet weniger offensichtliche Automatisierungsziele. Der Fokus sollte auf strategischer KI-Nutzung liegen — etwa Datenanalyse oder Prognosen.",
  "aicheck.insight.q1.mid": "Ein moderates Maß an repetitiver Arbeit bietet gute Einstiegspunkte. Gezielte Automatisierung einzelner Prozesse kann spürbare Effizienzgewinne bringen.",
  "aicheck.insight.q1.high": "Hoher Anteil repetitiver Arbeit ist ideales Automatisierungspotenzial. KI-Workflows können hier sofort signifikante Zeitersparnis und Kostensenkung liefern.",
  "aicheck.recommend.q1.low": "Prüfen Sie, ob versteckte Automatisierungspotenziale existieren — oft sind repetitive Teilschritte in komplexen Prozessen verborgen.",
  "aicheck.recommend.q1.mid": "Identifizieren Sie die 2-3 zeitintensivsten repetitiven Aufgaben und starten Sie dort mit der Automatisierung.",
  "aicheck.recommend.q1.high": "Starten Sie sofort mit dem Prozess, der die meiste manuelle Zeit frisst — dort ist der ROI am höchsten.",

  // Q2: Digitalisierte Daten
  "aicheck.insight.q2.low": "Ohne strukturierte Daten ist KI-Implementierung schwierig. Digitalisierung und Datenstrukturierung sind der wichtigste erste Schritt.",
  "aicheck.insight.q2.mid": "Teilweise digitalisierte Daten sind eine solide Ausgangslage. Mit gezielter Strukturierung können Sie schnell KI-ready werden.",
  "aicheck.insight.q2.high": "Voll digitalisierte und strukturierte Daten sind die beste Voraussetzung für KI. Sie können direkt mit der Implementierung starten.",
  "aicheck.recommend.q2.low": "Investieren Sie zuerst in Digitalisierung. Ein Data Audit zeigt, welche Daten priorisiert digitalisiert werden sollten.",
  "aicheck.recommend.q2.mid": "Fokussieren Sie auf Datenqualität und -struktur. API-Anbindungen beschleunigen die KI-Integration erheblich.",
  "aicheck.recommend.q2.high": "Ihre Datenbasis ist bereit für KI. Starten Sie mit einem Pilotprojekt, das Ihre besten Datenquellen nutzt.",

  // Q3: Kundenanfragen pro Woche
  "aicheck.insight.q3.low": "Bei wenigen Anfragen lohnt sich ein Chatbot weniger. Fokussieren Sie auf interne Prozessoptimierung mit KI.",
  "aicheck.insight.q3.mid": "Ein moderates Anfragevolumen eignet sich gut für eine KI-gestützte FAQ-Automatisierung oder E-Mail-Klassifizierung.",
  "aicheck.insight.q3.high": "Hohes Anfragevolumen ist ideal für KI-Chatbots und automatische Klassifizierung — mit sofortiger ROI-Wirkung.",
  "aicheck.recommend.q3.low": "Nutzen Sie KI für qualitative Verbesserung statt Volumenautomatisierung — z.B. Sentiment-Analyse oder personalisierte Antworten.",
  "aicheck.recommend.q3.mid": "Ein KI-gestütztes Ticketing-System kann Anfragen automatisch priorisieren und häufige Fragen beantworten.",
  "aicheck.recommend.q3.high": "Ein KI-Chatbot für häufige Fragen kann die Bearbeitungszeit um 60-80% reduzieren. Idealer erster KI-Einsatz.",

  // Q4: Automatisierungstools
  "aicheck.insight.q4.low": "Ohne bestehende Automatisierung starten Sie von Grund auf. Das bietet die Chance, direkt auf moderne KI-gestützte Tools zu setzen.",
  "aicheck.insight.q4.mid": "Vorhandene Automatisierung ist eine gute Basis. KI kann auf bestehende Workflows aufbauen und sie um intelligente Entscheidungen erweitern.",
  "aicheck.insight.q4.high": "Fortgeschrittene Automatisierung ist die perfekte Grundlage für KI-Integration. Sie können bestehende Systeme nahtlos um KI-Komponenten erweitern.",
  "aicheck.recommend.q4.low": "Starten Sie mit einfachen Workflow-Automationen (z.B. n8n) als Fundament, bevor Sie KI-Komponenten hinzufügen.",
  "aicheck.recommend.q4.mid": "Erweitern Sie bestehende Workflows um KI-Bausteine — das senkt Risiko und beschleunigt die Implementierung.",
  "aicheck.recommend.q4.high": "Integrieren Sie KI-Agenten und RAG-Systeme in Ihre bestehende Automatisierungslandschaft für maximalen Mehrwert.",

  // Q5: Budget für KI
  "aicheck.insight.q5.low": "Ein kleineres Budget bedeutet fokussierte Einstiege. Schon mit EUR 5.000 lassen sich wertvolle erste KI-Erfahrungen sammeln.",
  "aicheck.insight.q5.mid": "Ein mittleres Budget ermöglicht substantielle KI-Projekte — vom AI Sprint bis zum ersten produktiven MVP.",
  "aicheck.insight.q5.high": "Mit diesem Budget können Sie umfassende KI-Initiativen starten — von Custom LLMs bis hin zu unternehmensweiten Automatisierungen.",
  "aicheck.recommend.q5.low": "Unser AI Sprint (ab EUR 5.000, 2 Wochen) ist der ideale Einstieg — fokussiert, schnell und mit konkretem Ergebnis.",
  "aicheck.recommend.q5.mid": "Planen Sie ein MVP-Projekt, das in 4-8 Wochen erste messbare Ergebnisse liefert und als Proof of Concept dient.",
  "aicheck.recommend.q5.high": "Investieren Sie in eine KI-Strategie mit mehreren Pilotprojekten parallel — maximaler Lerneffekt und schnellere Skalierung.",

  // Q6: Technikaffinität des Teams
  "aicheck.insight.q6.low": "Ein weniger technikaffines Team braucht mehr Begleitung. Wir setzen auf intuitive Lösungen und intensive Schulungen.",
  "aicheck.insight.q6.mid": "Ein technisch versiertes Team kann KI-Tools schnell adoptieren. Der Fokus liegt auf Enablement und Best Practices.",
  "aicheck.insight.q6.high": "Ein hochgradig technisches Team kann KI-Lösungen aktiv mitgestalten und eigenständig weiterentwickeln.",
  "aicheck.recommend.q6.low": "Starten Sie mit No-Code/Low-Code KI-Tools und begleitenden Workshops, um das Team schrittweise aufzubauen.",
  "aicheck.recommend.q6.mid": "Nutzen Sie Pair-Programming-Sessions und Hands-on-Workshops, um KI-Kompetenz im Team gezielt zu vertiefen.",
  "aicheck.recommend.q6.high": "Setzen Sie auf Co-Development — Ihr Team baut KI-Lösungen aktiv mit, für maximalen Wissenstransfer.",

  // Q7: Zeitrahmen für Ergebnisse
  "aicheck.insight.q7.low": "Ohne Zeitdruck können Sie eine durchdachte KI-Strategie entwickeln und schrittweise implementieren.",
  "aicheck.insight.q7.mid": "Ein moderater Zeitrahmen erlaubt solide Planung bei gleichzeitig zügiger Umsetzung. Ideal für erste MVP-Projekte.",
  "aicheck.insight.q7.high": "Kurzer Zeitrahmen erfordert fokussierte Lösungen. Ein AI Sprint liefert in 2 Wochen erste konkrete Ergebnisse.",
  "aicheck.recommend.q7.low": "Nutzen Sie die Zeit für eine gründliche Bestandsaufnahme und strategische Roadmap-Planung.",
  "aicheck.recommend.q7.mid": "Planen Sie einen AI Sprint als Kickoff, gefolgt von einer iterativen MVP-Phase mit klaren Meilensteinen.",
  "aicheck.recommend.q7.high": "Für schnelle Ergebnisse: AI Sprint in 2 Wochen. Wir liefern einen funktionierenden Prototyp mit messbarem Impact.",

  // AI Readiness Assessment — Shared View
  "aicheck.shared.title": "Möchten Sie Ihren eigenen Score erfahren?",
  "aicheck.shared.desc": "Machen Sie den kostenlosen AI-Readiness-Check und erhalten Sie eine personalisierte Analyse für Ihr Unternehmen.",
  "aicheck.shared.cta": "Jetzt Assessment starten",

  // AI Readiness Assessment — Share
  "aicheck.share.title": "Ergebnis teilen",
  "aicheck.share.copy": "Link kopieren",
  "aicheck.share.copied": "Kopiert!",
  "aicheck.share.linkedin": "Auf LinkedIn teilen",

  // AI Readiness Assessment — PDF
  "aicheck.pdf.download": "Report als PDF herunterladen",
  "aicheck.pdf.generating": "PDF wird erstellt...",
  "aicheck.pdf.hint": "Nach Eingabe Ihrer E-Mail können Sie den vollständigen Report als PDF herunterladen.",

  // Tech Radar — Page
  "radar.label": "Technology Radar",
  "radar.title": "TECH RADAR",
  "radar.description": "Welche Technologien wir aktiv einsetzen, evaluieren oder bewusst nicht verwenden. Transparenz statt Marketing-Versprechen.",
  "radar.updated": "Letztes Update: Q1 2026",

  // Tech Radar — Rings
  "radar.ring.adopt": "Adopt",
  "radar.ring.trial": "Trial",
  "radar.ring.assess": "Assess",
  "radar.ring.hold": "Hold",
  "radar.ring.adopt.desc": "Bewährt und produktionsreif. Aktiv im Einsatz für Kundenprojekte.",
  "radar.ring.trial.desc": "Vielversprechend. Im Einsatz für ausgewählte Projekte und Prototypen.",
  "radar.ring.assess.desc": "Interessant. Wird aktiv evaluiert und beobachtet.",
  "radar.ring.hold.desc": "Nur für Legacy-Projekte. Keine Neuimplementierung empfohlen.",

  // Tech Radar — Quadrants
  "radar.quadrant.ai": "KI & ML",
  "radar.quadrant.frontend": "Frontend & Mobile",
  "radar.quadrant.backend": "Backend & DevOps",
  "radar.quadrant.cloud": "Cloud & Infra",

  // Tech Radar — Technologies
  "radar.tech.langchain": "LangChain",
  "radar.tech.langchain.desc": "Framework für LLM-Anwendungen und RAG-Pipelines. Produktionsreif für Enterprise-Kunden.",
  "radar.tech.n8n": "n8n",
  "radar.tech.n8n.desc": "Open-Source Workflow Automation. Self-hosted für volle DSGVO-Konformität.",
  "radar.tech.langgraph": "LangGraph",
  "radar.tech.langgraph.desc": "Framework für Multi-Agent-Systeme und komplexe KI-Workflows mit State Management.",
  "radar.tech.ollama": "Ollama",
  "radar.tech.ollama.desc": "Lokale LLM-Inferenz für maximale Datensicherheit. Ideal für DSGVO-sensible Anwendungen.",
  "radar.tech.edge-ai": "Edge AI",
  "radar.tech.edge-ai.desc": "KI-Inferenz direkt auf Edge-Geräten. Interessant für IoT und latenz-kritische Anwendungen.",
  "radar.tech.nextjs": "Next.js",
  "radar.tech.nextjs.desc": "React-Framework für Production-Websites. SSR, SSG, Edge Deployment — unser Standard für Web.",
  "radar.tech.flutter": "Flutter",
  "radar.tech.flutter.desc": "Cross-platform Mobile & Web mit einer Codebase. Unser Standard für App-Entwicklung.",
  "radar.tech.deno": "Deno",
  "radar.tech.deno.desc": "Sichere TypeScript-Runtime mit eingebautem Tooling. Vielversprechende Alternative zu Node.js.",
  "radar.tech.bun": "Bun",
  "radar.tech.bun.desc": "Ultraschnelle JavaScript-Runtime und Package Manager. Im Trial für Build-Tools und Scripts.",
  "radar.tech.wasm": "WebAssembly",
  "radar.tech.wasm.desc": "Near-native Performance im Browser. Wird evaluiert für rechenintensive Client-Anwendungen.",
  "radar.tech.jquery": "jQuery",
  "radar.tech.jquery.desc": "Nur für Legacy-Wartung. Keine Neuimplementierung — moderne Alternativen sind überlegen.",
  "radar.tech.angular": "Angular",
  "radar.tech.angular.desc": "Nur für bestehende Projekte. Für Neuimplementierungen setzen wir auf Next.js/React.",
  "radar.tech.docker": "Docker",
  "radar.tech.docker.desc": "Container-Standard für reproduzierbare Deployments. Grundlage unserer DevOps-Strategie.",
  "radar.tech.rust": "Rust",
  "radar.tech.rust.desc": "Systemnahe Programmierung mit Memory Safety. Wird evaluiert für performance-kritische Backend-Services.",
  "radar.tech.php": "PHP",
  "radar.tech.php.desc": "Nur für Legacy-Wartung. Für neue Projekte setzen wir auf Node.js oder Python.",
  "radar.tech.java": "Java",
  "radar.tech.java.desc": "Nur für Legacy-Wartung. Für neue Projekte setzen wir auf Node.js oder Python.",
  "radar.tech.cloudflare": "Cloudflare",
  "radar.tech.cloudflare.desc": "Edge-Computing, DNS, CDN und Workers. Unsere bevorzugte Plattform für Web-Deployment.",
  "radar.tech.terraform": "OpenTofu",
  "radar.tech.terraform.desc": "Infrastructure as Code für reproduzierbare, versionierte Cloud-Infrastruktur.",
  "radar.tech.typescript": "TypeScript",
  "radar.tech.typescript.desc": "Stark typisierte Erweiterung von JavaScript für skalierbare und wartbare Web-Applikationen.",
  "radar.tech.supabase": "Supabase",
  "radar.tech.supabase.desc": "Open-Source Firebase Alternative — PostgreSQL-Datenbank mit Auth, Realtime und Edge-Functions.",
  "radar.tech.postgresql": "PostgreSQL",
  "radar.tech.postgresql.desc": "Die modernste Open-Source-Datenbank für komplexe, relationale Datenstrukturen.",
  "radar.tech.python": "Python",
  "radar.tech.python.desc": "Standard-Sprache für KI, Datenanalyse und robuste Backend-Systeme.",
  "radar.tech.github-actions": "GitHub Actions",
  "radar.tech.github-actions.desc": "Automatisierte CI/CD-Pipelines für Testing, Build und Deployment direkt in GitHub.",
  "radar.tech.traefik": "Traefik",
  "radar.tech.traefik.desc": "Moderner Cloud-Native Edge-Router und Load-Balancer für Microservice-Architekturen.",
  "radar.tech.proxmox": "Proxmox",
  "radar.tech.proxmox.desc": "Open-Source Virtualisierungs-Plattform für On-Premise Cloud und Server-Management.",
  "radar.tech.mqtt": "MQTT",
  "radar.tech.mqtt.desc": "Leichtgewichtiges Messaging-Protokoll für IoT-Kommunikation und Maschine-zu-Maschine-Interaktion.",
  "radar.tech.llamacpp": "Llama.cpp",
  "radar.tech.llamacpp.desc": "Portierung des LLaMA-Modells in C/C++. Ermöglicht die lokale Ausführung von LLMs auf Consumer-Hardware.",
  "radar.tech.rag": "RAG",
  "radar.tech.rag.desc": "Retrieval-Augmented Generation. Verknüpfung von LLMs mit internem Unternehmenswissen.",
  "radar.tech.fastmcp": "FastMCP",
  "radar.tech.fastmcp.desc": "Performantes Model Context Protocol Server-Framework für Claude.",
  "radar.tech.nodered": "Node-RED",
  "radar.tech.nodered.desc": "Visuelles Programmierwerkzeug zur Verknüpfung von Hardware, APIs und Online-Diensten.",
  "radar.tech.react": "React",
  "radar.tech.react.desc": "Bibliothek für Web- und Native-User-Interfaces. Unser primäres Frontend-Framework.",
  "radar.tech.tailwindcss": "Tailwind CSS",
  "radar.tech.tailwindcss.desc": "Utility-first CSS Framework für die schnelle Entwicklung von User Interfaces.",
  "radar.tech.nodejs": "Node.js",
  "radar.tech.nodejs.desc": "Ereignisgesteuerte JavaScript-Laufzeitumgebung. Eingesetzt für skalierbare Backend-Anwendungen.",
  "radar.tech.nestjs": "NestJS",
  "radar.tech.nestjs.desc": "Modernes Node.js-Framework für den Aufbau effizienter, zuverlässiger und skalierbarer serverseitiger Anwendungen.",
  "radar.tech.django": "Django",
  "radar.tech.django.desc": "High-Level Python Web-Framework, das schnelle Entwicklung und pragmatisches Design fördert.",
  "radar.tech.firebase": "Firebase",
  "radar.tech.firebase.desc": "Backend-as-a-Service Plattform. Abhängig von den spezifischen Kundenanforderungen.",
  "radar.tech.ansible": "Ansible",
  "radar.tech.ansible.desc": "IT-Automatisierungstool für Konfigurationsmanagement und Anwendungs-Deployment.",
  "radar.tech.aws": "AWS",
  "radar.tech.aws.desc": "Amazon Web Services. Die am weitesten verbreitete und umfassendste Cloud-Plattform.",
  "radar.tech.azure": "Azure",
  "radar.tech.azure.desc": "Microsofts Cloud-Plattform. Oft die erste Wahl bei Enterprise-Kunden im Microsoft-Ökosystem.",
  "radar.tech.gcp": "GCP",
  "radar.tech.gcp.desc": "Google Cloud Platform. Stark in den Bereichen Datenanalyse und Machine Learning.",
  "radar.tech.mysql": "MySQL",
  "radar.tech.mysql.desc": "Open-Source relationales Datenbankverwaltungssystem. Solide Alternative zu PostgreSQL.",
  "radar.tech.mongodb": "MongoDB",
  "radar.tech.mongodb.desc": "Dokumentenorientierte NoSQL-Datenbank für unstrukturierte oder sich schnell ändernde Daten.",
  "radar.tech.authentik": "Authentik",
  "radar.tech.authentik.desc": "Open-Source Identity Provider mit Fokus auf Flexibilität und Vielseitigkeit.",
  "radar.tech.oidc": "OIDC / OAuth2",
  "radar.tech.oidc.desc": "OpenID Connect und OAuth 2.0. Standardprotokolle für moderne Authentifizierung und Autorisierung.",
  "radar.tech.platformio": "PlatformIO",
  "radar.tech.platformio.desc": "Professionelle kollaborative Plattform für Embedded Development.",
  "radar.tech.arduino": "Arduino",
  "radar.tech.arduino.desc": "Open-Source Prototyping-Plattform für elektronische Hardware-Projekte und IoT.",
  "radar.tech.figma": "Figma / Penpot",
  "radar.tech.figma.desc": "Kollaborative Interface-Design-Tools. Essenziell für unsere UI/UX-Prototyping-Phase.",

  // Tech Radar — CTA
  "radar.cta.title": "Technologieberatung gewünscht?",
  "radar.cta.desc": "Lassen Sie uns gemeinsam den richtigen Stack für Ihr Projekt definieren.",
  "radar.cta.button": "TECH CONSULTING ANFRAGEN",

  // AI Chat Demo Widget
  "chat.bubble.label": "KI-Assistent",
  "chat.panel.title": "AI Assistant",
  "chat.welcome": "Hallo! Wie kann ich Ihnen helfen?",
  "chat.welcome.desc": "Fragen Sie mich zu unseren Leistungen, Technologien oder wie KI Ihrem Unternehmen helfen kann.",
  "chat.input.placeholder": "Nachricht eingeben...",
  "chat.send": "Senden",
  "chat.error.generic": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
  "chat.error.rateLimit": "Zu viele Anfragen. Bitte warten Sie einen Moment.",
  "chat.error.rateLimitDaily": "Tageslimit an Fragen erreicht.",
  "chat.error.network": "Verbindungsfehler. Bitte prüfen Sie Ihre Internetverbindung.",
  // Spoken by the assistant itself when it cannot answer — see
  // src/lib/chat/conversation.tsx. {email} and {phone} are filled from COMPANY
  // in src/data/knowledge/company.ts, the record the model reads them from too.
  "chat.unavailable": "Der KI-Dienst ist im Moment nicht erreichbar. Schreiben Sie uns bitte an {email} oder rufen Sie an: {phone}.",
  "chat.quotaReached": "Sie haben die Anzahl an Fragen erreicht, die der Assistent pro Tag beantwortet — morgen steht er wieder zur Verfügung. In der Zwischenzeit: {email} oder {phone}.",
  "chat.busy": "Gerade sind sehr viele Anfragen unterwegs — bitte versuchen Sie es in einem Moment noch einmal. Wenn es eilt: {email} oder {phone}.",
  "chat.typing": "Schreibt...",
  "chat.clear": "Chat leeren",
  "chat.cta": "KOSTENLOSES ERSTGESPRÄCH BUCHEN",
  "chat.close": "Schließen",
  "chat.askbar.label": "Frage an den KI-Assistenten",
  "chat.askbar.placeholder": "Fragen Sie unsere KI",
  // Kein Tempoversprechen: Antworten dauern, so lange sie dauern, und eine
  // langsame würde das Label der Bar selbst widerlegen. Bleibt die eine Angabe,
  // die belegt ist — TensorX Limited, Dublin, EU-Verarbeitung und zero data
  // retention, siehe docs/compliance/ki-kompetenz.md.
  "chat.askbar.status": "EU-Hosted",
  // Die Auskunft nach Art. 13 DSGVO an der Stelle, an der erhoben wird: sie
  // steht im Assistenten selbst, bevor die erste Nachricht abgeschickt wird.
  // {days} trägt die tatsächlich eingestellte Aufbewahrungsdauer — siehe
  // RECORD_RETENTION_DAYS in src/lib/chat/config.ts.
  "chat.recording.notice": "Dieses Gespräch wird {days} Tage gespeichert — zur Sicherheit des Assistenten und zur Prüfung der Antwortqualität. Länger nur, wenn ein konkreter Vorfall untersucht wird.",
  "chat.recording.rules": "Nutzungsregeln",
  "chat.recording.privacy": "Datenschutz",
  "chat.action.contact.title": "Anfrage senden",
  "chat.action.contact.hint": "Prüfen Sie die Angaben und senden Sie die Anfrage ab. Vorher wird nichts verschickt.",
  "chat.action.contact.submit": "ANFRAGE SENDEN",
  "chat.action.contact.sending": "Wird gesendet...",
  "chat.action.contact.success": "Danke, Ihre Anfrage ist angekommen. Sie erhalten in Kürze eine Antwort.",
  "chat.action.contact.error": "Die Anfrage konnte nicht gesendet werden. Bitte schreiben Sie an {email}.",
  "chat.action.dismiss": "Nicht jetzt",
  "chat.action.readiness.title": "KI-Readiness-Check",
  "chat.action.readiness.cta": "CHECK STARTEN",
  "chat.action.navigate.cta": "SEITE ÖFFNEN",
  // Für Screenreader: der Linkname nennt das Ziel, die Ansage meldet ein neu
  // angebotenes Element, ohne den Fokus zu verschieben. {page} ist der Seitenname.
  "chat.action.readiness.label": "Check starten: {page}",
  "chat.action.navigate.label": "Seite öffnen: {page}",
  "chat.action.contact.announce": "Kontaktformular angeboten.",
  "chat.action.navigate.announce": "Seite angeboten: {page}.",
  "chat.action.dismissed": "Angebot ausgeblendet",

  // KMU AI Playbook
  "playbook.label": "KMU AI Playbook",
  "playbook.title": "5 KI Quick Wins für Ihr Unternehmen",
  "playbook.subtitle": "Kostenlos per E-Mail — sofort umsetzbare KI-Strategien für österreichische KMUs",
  "playbook.preview.title": "Was Sie erhalten:",
  "playbook.item1": "FAQ-Chatbot automatisieren",
  "playbook.item1.desc": "Beantworten Sie wiederkehrende Kundenanfragen automatisch — rund um die Uhr.",
  "playbook.item2": "Dokumentenverarbeitung mit n8n + LLM",
  "playbook.item2.desc": "Automatische Klassifikation, Extraktion und Weiterleitung von Dokumenten.",
  "playbook.item3": "Interne Wissensdatenbank mit RAG aufbauen",
  "playbook.item3.desc": "Machen Sie Ihr internes Wissen per KI-Suche zugänglich für Ihr Team.",
  "playbook.item4": "Meeting-Zusammenfassungen mit KI",
  "playbook.item4.desc": "Automatische Protokolle und Action Items direkt nach jedem Meeting.",
  "playbook.item5": "Lead-Scoring mit KI-Klassifikation",
  "playbook.item5.desc": "Priorisieren Sie Ihre Leads automatisch nach Kaufwahrscheinlichkeit.",
  "playbook.form.email": "Ihre E-Mail-Adresse",
  "playbook.form.company": "Unternehmen (optional)",
  "playbook.form.submit": "JETZT KOSTENLOS HERUNTERLADEN",
  "playbook.form.sending": "WIRD GESENDET...",
  "playbook.success.title": "Ihr Playbook ist unterwegs!",
  "playbook.success.desc": "Prüfen Sie Ihren Posteingang — der Download-Link ist bereits auf dem Weg.",
  "playbook.success.link": "Direkt zum Inhalt",
  "playbook.error": "Fehler beim Senden. Bitte versuchen Sie es erneut.",
  "playbook.privacy": "Kein Spam. Keine Weitergabe. Jederzeit abmeldbar.",

  // KMU AI Playbook Content Page
  "playbook.content.label": "KMU AI Playbook",
  "playbook.content.title": "5 KI Quick Wins für Ihr Unternehmen",
  "playbook.content.subtitle": "Praxiserprobte KI-Strategien, die Sie sofort in Ihrem Unternehmen einsetzen können.",
  "playbook.content.cta.title": "Bereit für den nächsten Schritt?",
  "playbook.content.cta.desc": "Lassen Sie uns gemeinsam herausfinden, welcher Quick Win den größten Impact für Ihr Unternehmen hat.",
  "playbook.content.cta.button": "KOSTENLOSES ERSTGESPRÄCH BUCHEN",

  // Partners Page
  "partners.page.label": "Unsere Partner",
  "partners.page.title": "PARTNER",
  "partners.page.description": "Strategische Partnerschaften für den gemeinsamen Erfolg.",

  // ============================================================
  // GLOBAL — Bottom
  // ============================================================

  // Footer
  "footer.impressum": "Impressum",
  "footer.datenschutz": "Datenschutz",
  "footer.agb": "AGB",
  "footer.nutzungsbedingungen": "Nutzungsbedingungen KI",
  "footer.customers": "Kunden",
  "footer.partners": "Partner",
  "footer.linkedin": "LinkedIn",
  "footer.aicheck": "AI Check",
  "footer.techradar": "Tech Radar",
  "footer.playbook": "AI Playbook",

  // Error Boundary
  "error.label": "SYSTEM ERROR",
  "error.title": "Ein unerwarteter Fehler ist aufgetreten",
  "error.description": "Wir wurden automatisch benachrichtigt und arbeiten an einer Lösung.",
  "error.retry": "ERNEUT VERSUCHEN",

  // Page Metadata
  "meta.home.title": "HAINTZ IT-SOLUTIONS | KI & Software",
  "meta.home.description": "Custom Software Development, KI-Integration und Digitale Transformation für österreichische KMUs. Architecture-First. Direct Access zum Lead Developer.",
  "meta.blog.title": "Blog",
  "meta.blog.description": "Insights zu Software Development, KI-Integration und Digitaler Transformation.",
  "blog.label": "Insights & Updates",
  "blog.heading": "BLOG",
  "blog.subtitle": "Technische Artikel, Case Studies und Insights zu KI-Integration, Software-Architektur und digitaler Transformation.",
  "blog.empty.title": "Coming Soon",
  "blog.empty.text": "Wir arbeiten an spannenden Inhalten zu KI, Software-Architektur und Automatisierung.",
  "blog.readMore": "Lesen",
  "blog.backToBlog": "Blog",
  "blog.backToAll": "Alle Artikel",
  "blog.requestProject": "Projekt anfragen",
  "blog.author.label": "Geschrieben von",
  "blog.author.role": "Gründer & Geschäftsführer, HAINTZ IT-SOLUTIONS",
  "meta.projects.title": "Projekte",
  "meta.projects.description": "Ausgewählte Referenzprojekte — von KI-Chatbots über Mobile Apps bis zur Cloud-Migration.",
  "meta.partners.title": "Partner & Cluster",
  "meta.partners.description": "Unsere Technologie-Partner und Cluster-Mitgliedschaften.",
  "meta.aiReadiness.title": "AI Readiness Assessment",
  "meta.aiReadiness.description": "Finden Sie heraus, wie bereit Ihr Unternehmen für KI-Integration ist. Kostenloser AI-Readiness-Check in 2 Minuten.",
  "meta.techRadar.title": "Tech Radar",
  "meta.techRadar.description": "Unser Technology Radar: Welche Technologien wir einsetzen, evaluieren oder bewusst nicht einsetzen.",
  // The descriptions come from summary in src/data/knowledge/services.ts.
  "meta.solutions.aiAutomation.title": "KI & Automation",
  "meta.solutions.webApps.title": "Web Applikationen",
  "meta.solutions.mobileApps.title": "Mobile Apps",
  "meta.solutions.backend.title": "Backend Entwicklung",
  "meta.solutions.devops.title": "DevOps & Infrastructure",
  "meta.solutions.consulting.title": "Consulting",
  "meta.playbook.title": "KMU AI Playbook — 5 KI Quick Wins",
  "meta.playbook.description": "Kostenlos per E-Mail: 5 sofort umsetzbare KI-Strategien für österreichische KMUs.",
  "meta.notFound.title": "Seite nicht gefunden",
  "meta.notFound.description": "Die angeforderte Seite existiert nicht.",
} as const;
